const PAGE_NUMBER_REGEX = /pn=[0-9]+/;
const PAGE_NUMBER_REGEX_AMPERSAND = /&pn=[0-9]+/;
const PAGE_NUMBER_REGEX_QUESTION_ONLY = /\?pn=[0-9]+/;
const PAGE_NUMBER_REGEX_QUESTION_AMPERSAND = /\?pn=[0-9]+&/;

export const updatePathPageNumber = (
    currentPath: string,
    pageNumber: number
) => {
    if (pageNumber === 1) {
        if (PAGE_NUMBER_REGEX_QUESTION_AMPERSAND.test(currentPath))
            return currentPath.replace(
                PAGE_NUMBER_REGEX_QUESTION_AMPERSAND,
                '?'
            );

        if (PAGE_NUMBER_REGEX_QUESTION_ONLY.test(currentPath))
            return currentPath.replace(PAGE_NUMBER_REGEX_QUESTION_ONLY, '');

        return currentPath.replace(PAGE_NUMBER_REGEX_AMPERSAND, '');
    }

    if (PAGE_NUMBER_REGEX.test(currentPath)) {
        return currentPath.replace(PAGE_NUMBER_REGEX, `pn=${pageNumber}`);
    }

    return currentPath.indexOf('?') !== -1
        ? `${currentPath}&pn=${pageNumber}`
        : `${currentPath}?pn=${pageNumber}`;
};
